import { defineStore } from 'pinia'
import { store } from '@/store'
import integralApi from '@/api/integralApi'
import { Code } from '@/config/httpCode'
import type { ResGetIntegralDetailItem } from '@/api/type/other'
interface IntegralConfigType {
  [key: string]: Omit<ResGetIntegralDetailItem, 'type'>
}

export const useIntegralStore = defineStore('integral', {
  state: () => ({
    integralConfig: {} as IntegralConfigType,
    integralArray: [] as ResGetIntegralDetailItem[],
  }),
  actions: {
    async getIntegralConsumption() {
      const res = await integralApi.getIntegralConsumptionDetail()
      if (res.statusCode === Code.SUCCESS.statusCode) {
        await this.setIntegralArray(res.data)
      }
    },
    async setIntegralArray(array: ResGetIntegralDetailItem[]) {
      this.integralArray = array
      if (array && array.length > 0) {
        await this.setIntegralConfig(array)
      }
    },
    // 设置积分配置
    setIntegralConfig(array: ResGetIntegralDetailItem[]) {
      if (!array || array.length === 0) return

      const config: IntegralConfigType = {}

      array.forEach((item) => {
        if (item && item.type) {
          const { type, ...rest } = item
          config[type] = rest
        }
      })

      this.integralConfig = config
    },
  },
})

export function useIntegralStoreHook() {
  return useIntegralStore(store)
}
